export const ACTIVE = {
  active: true,
};
